import { render, staticRenderFns } from "./DatabaseBuilderComponent.vue?vue&type=template&id=8135b66e&"
import script from "./DatabaseBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./DatabaseBuilderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports